<template>
  <div>
    <DefaultHeader />
    <slot />
    <DefaultFooter />
    <CookieModal v-if="showCookieModal" />
  </div>
</template>

<script setup lang="ts">
  const { showCookieModal } = useCookiesConsent()
</script>
